// Studio gear priority lists (EN/ES), budget tier thresholds, and plan compute.
// -- Budget Calculator ------------------------------------------------------

// Ordered priority list — buy first to last. Pricing is approximate USD.
// Each item has a stable `id` that is language-independent.
export const GEAR_PRIORITY_EN = [
  { id: "speedlight-1", name: "Speedlight #1 (Godox TT685 or similar)", cost: 150 },
  { id: "radio-trigger", name: "Radio trigger set (Godox X-Pro)", cost: 80 },
  { id: "light-stand-1", name: "Light stand #1 (air-cushioned, 8 ft)", cost: 40 },
  { id: "reflector-5in1", name: "5-in-1 collapsible reflector (42 in)", cost: 40 },
  { id: "sandbag-1", name: "Sandbag #1 (15 lb)", cost: 25 },
  { id: "softbox-medium", name: "Medium softbox (24 in) with speedring", cost: 80 },
  { id: "speedlight-2", name: "Speedlight #2 (for fill/rim)", cost: 150 },
  { id: "light-stand-2", name: "Light stand #2", cost: 40 },
  { id: "sandbag-2", name: "Sandbag #2", cost: 25 },
  { id: "bg-support", name: "Background support kit (10 ft)", cost: 120 },
  { id: "paper-white", name: "White seamless paper roll (9 ft)", cost: 60 },
  { id: "umbrella-shoot-through", name: "Shoot-through umbrella (43 in)", cost: 35 },
  { id: "posing-stool", name: "Posing stool (backless)", cost: 50 },
  { id: "apple-box", name: "Apple box (20 x 12 x 8 in)", cost: 70 },
  { id: "gaffer-extension", name: "Gaffer tape + 25 ft extension cord", cost: 40 },
  { id: "monolight-1", name: "Monolight #1 (Godox AD400, 400Ws)", cost: 300 },
  { id: "cstand-boom", name: "C-stand with grip head + boom arm", cost: 200 },
  { id: "softbox-large", name: "Large softbox (48 in) with grid", cost: 180 },
  { id: "paper-gray-black", name: "Gray + black seamless paper rolls", cost: 120 },
  { id: "beauty-dish", name: "Beauty dish (22 in) with grid & sock", cost: 150 },
  { id: "monolight-2", name: "Monolight #2 (second 400Ws)", cost: 300 },
  { id: "light-meter", name: "Sekonic L-308X light meter", cost: 280 },
  { id: "green-screen", name: "Green screen fabric + dedicated stand", cost: 150 },
  { id: "posing-table", name: "Posing / product table (white acrylic top)", cost: 250 },
  { id: "sandbags-extra", name: "Extra sandbags (x4) for C-stands", cost: 100 },
  { id: "gels-grids", name: "Color gels + grid spots set", cost: 120 },
  { id: "cstand-2", name: "Second C-stand + boom", cost: 200 },
  { id: "tether-cable", name: "Tether cable + table clamp (USB-C 15 ft)", cost: 90 },
  // --- Pro / Advanced tier ---
  { id: "calibrated-monitor", name: "Color-calibrated editing monitor (27 in)", cost: 650 },
  { id: "editing-suite", name: "Adobe Creative Cloud (1-year Photography plan)", cost: 240 },
  { id: "color-checker", name: "X-Rite ColorChecker + gray card", cost: 90 },
  { id: "fast-cards", name: "Fast SD / CFexpress cards (2 x 256 GB)", cost: 220 },
  { id: "raid-backup", name: "External RAID backup drive (4 TB)", cost: 280 },
  { id: "pro-tripod", name: "Pro tripod + ballhead (Manfrotto 055 class)", cost: 450 },
  { id: "gear-bag", name: "Shoulder / roller gear bag (airline carry-on)", cost: 280 },
  { id: "filter-kit", name: "Polarizer + ND filter set (77 mm)", cost: 180 },
  { id: "macro-ring-light", name: "Macro ring light", cost: 150 },
  { id: "wireless-tether", name: "Wireless tethering transmitter (Air Direct)", cost: 400 },
  { id: "bg-stand-heavy", name: "Heavy-duty 12 ft background crossbar + kit", cost: 200 },
  { id: "telephoto-zoom", name: "Pro telephoto zoom (70–200 mm f/2.8)", cost: 1800 },
  { id: "second-body", name: "Second camera body (backup / dual-card)", cost: 1200 },
  { id: "drone", name: "Compact drone kit (DJI Mini 4 Pro Fly More)", cost: 900 },
  { id: "photo-printer", name: "Pro photo inkjet printer (13 in)", cost: 800 },
];

export const GEAR_PRIORITY_ES = [
  { id: "speedlight-1", name: "Speedlight #1 (Godox TT685 o similar)", cost: 150 },
  { id: "radio-trigger", name: "Sistema de disparador de radio (Godox X-Pro)", cost: 80 },
  { id: "light-stand-1", name: "Tripode de luz #1 (con amortiguacion, 2.4 m)", cost: 40 },
  { id: "reflector-5in1", name: "Reflector plegable 5 en 1 (107 cm)", cost: 40 },
  { id: "sandbag-1", name: "Sandbag #1 (7 kg)", cost: 25 },
  { id: "softbox-medium", name: "Softbox medio (60 cm) con speedring", cost: 80 },
  { id: "speedlight-2", name: "Speedlight #2 (para fill/rim)", cost: 150 },
  { id: "light-stand-2", name: "Tripode de luz #2", cost: 40 },
  { id: "sandbag-2", name: "Sandbag #2", cost: 25 },
  { id: "bg-support", name: "Soporte de fondo (3 m)", cost: 120 },
  { id: "paper-white", name: "Rollo de papel seamless blanco (2.7 m)", cost: 60 },
  { id: "umbrella-shoot-through", name: "Sombrilla translucida (110 cm)", cost: 35 },
  { id: "posing-stool", name: "Banco de posado (sin respaldo)", cost: 50 },
  { id: "apple-box", name: "Apple box (50 x 30 x 20 cm)", cost: 70 },
  { id: "gaffer-extension", name: "Cinta gaffer + extension de 7.5 m", cost: 40 },
  { id: "monolight-1", name: "Monolight #1 (Godox AD400, 400Ws)", cost: 300 },
  { id: "cstand-boom", name: "C-stand con cabezal + brazo boom", cost: 200 },
  { id: "softbox-large", name: "Softbox grande (120 cm) con grid", cost: 180 },
  { id: "paper-gray-black", name: "Rollos de papel seamless gris + negro", cost: 120 },
  { id: "beauty-dish", name: "Beauty dish (56 cm) con grid y sock", cost: 150 },
  { id: "monolight-2", name: "Monolight #2 (segundo 400Ws)", cost: 300 },
  { id: "light-meter", name: "Fotometro Sekonic L-308X", cost: 280 },
  { id: "green-screen", name: "Pantalla verde + tripode dedicado", cost: 150 },
  { id: "posing-table", name: "Mesa de posado/producto (acrilico blanco)", cost: 250 },
  { id: "sandbags-extra", name: "Sandbags extra (x4) para C-stands", cost: 100 },
  { id: "gels-grids", name: "Set de geles de color + grid spots", cost: 120 },
  { id: "cstand-2", name: "Segundo C-stand + boom", cost: 200 },
  { id: "tether-cable", name: "Cable tethering + clamp (USB-C 4.5 m)", cost: 90 },
  // --- Nivel Pro / Avanzado ---
  { id: "calibrated-monitor", name: "Monitor de edicion calibrado (27 pulg)", cost: 650 },
  { id: "editing-suite", name: "Adobe Creative Cloud (plan Fotografia 1 ano)", cost: 240 },
  { id: "color-checker", name: "X-Rite ColorChecker + tarjeta gris", cost: 90 },
  { id: "fast-cards", name: "Memorias SD / CFexpress rapidas (2 x 256 GB)", cost: 220 },
  { id: "raid-backup", name: "Disco externo RAID de respaldo (4 TB)", cost: 280 },
  { id: "pro-tripod", name: "Tripode pro + rotula (clase Manfrotto 055)", cost: 450 },
  { id: "gear-bag", name: "Maleta / mochila profesional (tamano cabina)", cost: 280 },
  { id: "filter-kit", name: "Polarizador + filtros ND (77 mm)", cost: 180 },
  { id: "macro-ring-light", name: "Ring light macro", cost: 150 },
  { id: "wireless-tether", name: "Transmisor de tethering inalambrico (Air Direct)", cost: 400 },
  { id: "bg-stand-heavy", name: "Crossbar de fondo heavy-duty 3.6 m + kit", cost: 200 },
  { id: "telephoto-zoom", name: "Teleobjetivo pro (70–200 mm f/2.8)", cost: 1800 },
  { id: "second-body", name: "Segundo cuerpo de camara (respaldo / doble tarjeta)", cost: 1200 },
  { id: "drone", name: "Kit de drone compacto (DJI Mini 4 Pro Fly More)", cost: 900 },
  { id: "photo-printer", name: "Impresora pro de inyeccion para fotos (13 pulg)", cost: 800 },
];

export const TIER_THRESHOLDS = [
  { min: 10000, key: "pro" },
  { min: 5000, key: "advanced" },
  { min: 3000, key: "mid" },
  { min: 1200, key: "small" },
  { min: 400, key: "starter" },
  { min: 0, key: "essentials" },
];

export function computeBudgetPlan(budget, items, ownedIds = new Set()) {
  let remaining = budget;
  const owned = [];
  const affordable = [];
  const stretch = [];
  for (const item of items) {
    if (ownedIds.has(item.id)) {
      owned.push(item);
      continue;
    }
    if (remaining >= item.cost) {
      affordable.push(item);
      remaining -= item.cost;
    } else {
      stretch.push(item);
    }
  }
  const totalUsed = affordable.reduce((s, i) => s + i.cost, 0);
  const ownedValue = owned.reduce((s, i) => s + i.cost, 0);
  const tier = TIER_THRESHOLDS.find((t) => budget >= t.min).key;
  return {
    owned,
    affordable,
    stretch,
    totalUsed,
    remaining: budget - totalUsed,
    ownedValue,
    tier,
  };
}
